<template>
  <nav class="navbar">
    <div class="container" style="margin-top: -1px">
      <!-- 桌面端菜单（宽屏显示） -->
      <div ref="menuRef">
        <div v-if="!isMobile" style="display: flex">
          <div style="width: 100%" class="menu__wrap flex items-center">
            <div :span="3" ref="menuItemRef">
              <div
                class="menu-item menu-item--popover"
                @click="handleMenuItemClick(0)"
              >
                首页
              </div>
            </div>

            <div :span="3" v-for="item in menuData" :key="item.id">
              <div>
                <el-popover
                  placement="bottom"
                  trigger="hover"
                  :visible-arrow="false"
                  popper-class="menu-popper"
                  transition="none"
                >
                  <div
                    slot="reference"
                    class="menu-item menu-item--popover"
                    @click="handleMenuItemClick(item)"
                  >
                    {{ item.title }}
                  </div>

                  <div class="menu-item__wrap">
                    <div
                      v-for="item in item.children"
                      :key="item.id"
                      class="menu-item"
                      :style="{ width: menuItemWidth }"
                      @click="handleMenuItemClick(item)"
                    >
                      {{ item.title }}
                    </div>
                  </div>
                </el-popover>
              </div>
            </div>
          </div>
        </div>

        <!-- 移动端汉堡按钮 -->

        <div
          v-if="isMobile"
          class="flex items-center content-space-between"
          style="height: 42px; padding: 0 10px; color: #fff"
        >
          <div @click="handleMenuItemClick(0)">首页</div>

          <div @click="drawerVisible = true">
            <i class="el-icon-s-unfold" style="font-size: 20px"></i>
          </div>
        </div>
      </div>

      <!-- 移动端菜单 -->
      <el-drawer
        :with-header="false"
        :visible.sync="drawerVisible"
        direction="rtl"
        custom-class="drawer-custom"
      >
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
        >
          <slider-item
            v-for="(item, index) in menuData"
            :key="index"
            :item="item"
            @menu-click="handleMenuItemClick"
          />
        </el-menu>
      </el-drawer>
    </div>
  </nav>
</template>

<script>
import SliderItem from "@/components/SidebarItem"

import resizeMixin from "@/mixins/resize"

export default {
  name: "ResponsiveNavbar",

  components: { SliderItem },

  mixins: [resizeMixin],

  props: {},

  data() {
    return {
      menuItemWidth: 0,
      menuData: [],

      isMobile: false, // 当前是否为移动端（根据窗口宽度判断）
      drawerVisible: false,
    }
  },

  created() {
    const schoolIntro = JSON.parse(localStorage.getItem("schoolIntro"))
    this.menuData = schoolIntro.section || []
  },

  mounted() {
    setTimeout(() => {
      const schoolIntro = JSON.parse(localStorage.getItem("schoolIntro"))
      this.menuData = schoolIntro.section || []
    }, 300)
  },

  beforeDestroy() {},

  methods: {
    safePush(path, query) {
      console.log(this.$route.path, path)
      console.log(JSON.stringify(this.$route.query), JSON.stringify(query))

      if (
        this.$route.path !== path ||
        JSON.stringify(this.$route.query) !== JSON.stringify(query)
      ) {
        this.$router.push({ path, query })
      }
    },

    handleMenuItemClick(item) {
      console.log(`handleMenuItemClick`, item)

      // Article = 1,
      // List = 2,
      // Image_Text = 3,
      // Image = 4,
      // Link = 5,

      if (item === 0) {
        this.$router.push("/")
      }

      // const listType = [2, 3]

      //  this.$router.push(
      //         `/teachers?section_id=${this.params.section_id}&title=${this.params.title}`
      //       )

      if ([5].includes(item.content_model_id)) {
        window.open(item.url, "_blank")
      } else if ([4].includes(item.content_model_id)) {
        this.safePush(`/teachers`, {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([2].includes(item.content_model_id)) {
        this.safePush("/list", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([3].includes(item.content_model_id)) {
        this.safePush("/list-image", {
          section_id: String(item.id),
          title: item.title,
        })
      } else if ([1].includes(item.content_model_id)) {
        this.safePush(`/article`, {
          content_model_id: String(item.content_model_id),
          id: String(item.id),
        })
      }

      this.drawerVisible = false
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },

    onResize() {
      const menuRef = this.$refs.menuRef

      const menuWidth = menuRef.offsetWidth

      this.menuItemWidth = menuWidth / (this.menuData.length + 1) + "px"

      this.isMobile = window.innerWidth < 768 // 当窗口宽度小于 768px 时，认为是移动端
    },
  },
}
</script>

<style lang="scss">
/* 全局样式：作用到 Element UI 弹出层 */
.menu-popper {
  padding: 0 !important;
  margin: 0 !important;
  min-width: auto !important;
  color: #dfe1ed !important;
  font-size: 14px !important;
  // background-color: #1c3a97 !important;
  background-color: transparent !important;
  border: none !important;
  border-radius: 0px !important;
  box-shadow: none !important;
}
</style>

<style scoped lang="scss">
.navbar {
  background-color: #1c3a97;
  border-top: 1px solid #4461bd;
}

.menu__wrap {
  > div {
    flex: 1;
  }
}

.menu-item__wrap {
  // background-color: rgba(255, 255, 255, 0.7);

  background-color: rgba($color: #07298f, $alpha: 1);
}

.menu-item {
  width: 100%;
  height: 42px;
  text-align: center;
  line-height: 42px;
  // color: #737678;
  color: #f5f5f5;
  font-size: 14px;

  cursor: pointer;
  border-bottom: 1px solid #344ea2;

  &:hover {
    color: #fff;

    font-weight: bold;

    // color: #333;
  }

  &--popover {
    color: #dfe1ed;
    font-size: 16px;

    background-color: #1c3a97;

    &:hover {
      color: #dfe1ed;
      // background-color: #b0d031;
    }
  }
}

::v-deep .drawer-custom {
  width: 50% !important;
}
</style>
